var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51914 16.5938L20.6548 24.8908C21.4847 25.3444 22.467 25.2739 23.2207 24.6993C23.9767 24.1236 24.3105 23.1907 24.0921 22.2644L22.5355 15.6815C22.4875 15.4786 22.306 15.3356 22.0976 15.3365L12.3108 15.3786L12.3075 15.3786C11.8449 15.3786 11.4697 15.0045 11.4675 14.542C11.4652 14.0772 11.8404 13.7009 12.3041 13.6986L22.1097 13.6554C22.3167 13.6545 22.4961 13.5119 22.5437 13.3105L24.0921 6.76359C24.3105 5.83735 23.9767 4.90327 23.2207 4.32647C22.7951 4.00279 22.2956 3.83815 21.7927 3.83815C21.4063 3.83815 21.0155 3.93559 20.6548 4.13383L5.51914 12.4308C4.74857 12.8541 4.28826 13.6314 4.28826 14.5129C4.28826 15.3932 4.74857 16.1716 5.51914 16.5938Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.62d976ef.svg";
export { ForwardRef as ReactComponent };